<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  data: () => ({
    buttonModalProps: {
      style: {
        display: 'none',
      },
    },
  }),
  async mounted() {
    const redirect = () => !(['/login', '/password/reset', '/password/forget'].includes(window.location.pathname));

    this.$authorization.on('expired', (token) => {
      if (token === 'refreshToken') this.$authorization.logout();
      if (redirect() && token === 'refreshToken') this.$router.push({ name: 'login' });
    });

    this.$authorization.on('empty', () => (redirect()) && this.$router.push({ name: 'login' }));

    this.$authorization.on('error', (error) => {
      if (redirect()) this.$router.push({ name: 'login' });
      this.$authorization.logout();
    });

    this.$authorization.on('renewed', () => this.setAuthorizationHeader());
    this.$authorization.on('load', async () => {
      this.setAuthorizationHeader();
      await this.wait(1000);
      await this.getUserMetadata();
    });
    await this.$authorization.set();

    if (!Object.is) {
      Object.is = function (x, y) {
      // SameValue algorithm
        if (x === y) { // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
          return x !== 0 || 1 / x === 1 / y;
        }
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      };
    }
  },
  methods: {
    setAuthorizationHeader() {
      const { storage, keys } = this.$authorization;
      const accessToken = this.$authorization.constructor.getTokens(storage, keys, 'accessToken');
      this.axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    },
    getUserMetadata() {
      const decode = JWT => JSON.parse(atob(JWT.split('.')[1]));
      const { storage, keys } = this.$authorization;
      const accessToken = this.$authorization.constructor.getTokens(storage, keys, 'accessToken');
      const { aud, org } = decode(accessToken);
      this.$store.commit('global/account', org);
      this.$store.commit('global/id', aud);
      return this.$store.dispatch('global/getUserData');
    },
    wait(timeout = 1000) {
      return new Promise(resolve => setTimeout(resolve, timeout));
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

html, body {
  font-family: 'Inter', sans-serif;
}

#app {
  width: 100%;
  height: 100%;
}

  .vd__help_modal [class*="footer"] {
    display: none;
  }
</style>

<style>
.ivu-modal{width:auto;margin:0 auto;position:relative;outline:0;top:100px}.ivu-modal-hidden{display:none!important}.ivu-modal-wrap{position:fixed;overflow:auto;top:0;right:0;bottom:0;left:0;z-index:1000;-webkit-overflow-scrolling:touch;outline:0}.ivu-modal-wrap *{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-tap-highlight-color:transparent}.ivu-modal-mask{position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(55,55,55,.6);height:100%;z-index:1000}.ivu-modal-mask-hidden{display:none}.ivu-modal-content{position:relative;background-color:#fff;border:0;border-radius:6px;background-clip:padding-box;-webkit-box-shadow:0 4px 12px rgba(0,0,0,.15);box-shadow:0 4px 12px rgba(0,0,0,.15)}.ivu-modal-content-no-mask{pointer-events:auto}.ivu-modal-content-drag{position:absolute}.ivu-modal-content-drag .ivu-modal-header{cursor:move}.ivu-modal-content-dragging{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ivu-modal-header{border-bottom:1px solid #e8eaec;padding:14px 16px;line-height:1}.ivu-modal-header p,.ivu-modal-header-inner{display:inline-block;width:100%;height:20px;line-height:20px;font-size:14px;color:#17233d;font-weight:700;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ivu-modal-header p i,.ivu-modal-header p span{vertical-align:middle}.ivu-modal-close{z-index:1;font-size:12px;position:absolute;right:8px;top:8px;overflow:hidden;cursor:pointer}.ivu-modal-close .ivu-icon-ios-close{font-size:31px;color:#999;-webkit-transition:color .2s ease;transition:color .2s ease;position:relative;top:1px}.ivu-modal-close .ivu-icon-ios-close:hover{color:#444}.ivu-modal-body{padding:16px;font-size:12px;line-height:1.5}.ivu-modal-footer{border-top:1px solid #e8eaec;padding:12px 18px 12px 18px;text-align:right}.ivu-modal-footer button+button{margin-left:8px;margin-bottom:0}.ivu-modal-fullscreen{width:100%!important;top:0;bottom:0;position:absolute}.ivu-modal-fullscreen .ivu-modal-content{width:100%;border-radius:0;position:absolute;top:0;bottom:0}.ivu-modal-fullscreen .ivu-modal-body{width:100%;overflow:auto;position:absolute;top:51px;bottom:61px}.ivu-modal-fullscreen-no-header .ivu-modal-body{top:0}.ivu-modal-fullscreen-no-footer .ivu-modal-body{bottom:0}.ivu-modal-fullscreen .ivu-modal-footer{position:absolute;width:100%;bottom:0}.ivu-modal-no-mask{pointer-events:none}@media (max-width:576px){.ivu-modal{width:auto!important;margin:10px}.ivu-modal-fullscreen{width:100%!important;margin:0}.vertical-center-modal .ivu-modal{-webkit-box-flex:1;-ms-flex:1;flex:1}}.ivu-modal-confirm{padding:0 4px}.ivu-modal-confirm-head{padding:0 12px 0 0}.ivu-modal-confirm-head-icon{display:inline-block;font-size:28px;vertical-align:middle;position:relative;top:-2px}.ivu-modal-confirm-head-icon-info{color:#2d8cf0}.ivu-modal-confirm-head-icon-success{color:#19be6b}.ivu-modal-confirm-head-icon-warning{color:#f90}.ivu-modal-confirm-head-icon-error{color:#ed4014}.ivu-modal-confirm-head-icon-confirm{color:#f90}.ivu-modal-confirm-head-title{display:inline-block;vertical-align:middle;margin-left:12px;font-size:16px;color:#17233d;font-weight:700}.ivu-modal-confirm-body{padding-left:42px;font-size:14px;color:#515a6e;position:relative}.ivu-modal-confirm-body-render{margin:0;padding:0}.ivu-modal-confirm-footer{margin-top:20px;text-align:right}.ivu-modal-confirm-footer button+button{margin-left:8px;margin-bottom:0}
</style>
